module.exports = "/_next/static/images/Hero@2x-273c38304240112e3bf510f7f6a30b1f.png";